<div class="new_product_page">
  <div class="product_page_div">
    <div class="bg-img">
      <img src="assets/images/sso/new-bg.png" alt="bg-image">
    </div>
    <div class="product_page_header">
      <div class="page_header_logo">
        <img src="assets/images/new_logo.png" alt="logo">
      </div>
      <div class="page_header_btn">
        <button class="btn">
          <img src="assets/images/sso/user.png" alt="user"><span class="name">Welcome, {{UserName}}</span>
        </button>
      </div>
      <div class="page_header_btn btn-2">
        <button class="btn mr-2" (click)="openChangePassword()">
          <img class="mr-2" src="assets/images/sso/reset-password.png" alt="reset-password"><span>Change Password</span>
        </button>
        <button class="btn px-2" (click)="LogOut()">
          <img class="mr-0" src="assets/images/sso/turn-off.png" alt="turn-off">
          <!-- <img src="assets/images/sso/turn-off.png" alt="turn-off"> -->
          <!-- <span>Log Out</span> -->
        </button>
      </div>
    </div>
    <div class="dashboard_page">
      <div class="container">
        <div class="row">
          <div class="col-md-3" *ngIf="isMDB">
            <a (click)="MDBNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/Master.png'" alt="Master">
                <p>MDB</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isPNS">
            <a (click)="PNSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/PNS.png'" alt="P&S">
                <p>P&S</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isDMS">
            <a (click)="DMSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/DMS.png'" alt="DMS">
                <p>DMS</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isAFCS">
            <a (click)="AFCSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/afcs.png'" alt="AFCS">
                <p>AFCS</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isAVLS">
            <a (click)="AVLSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/AVLS.png'" alt="AVLS">
                <p>AVLS</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isHRMS">
            <a (click)="HRMSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/hrms.png'" alt="MMS">
                <p>MMS</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isGRMS">
            <a (click)="GRMSNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/grms.png'" alt="GRMS">
                <p>GRMS</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isOPRSCounter">
            <a (click)="OPRSCounterNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/counter.png'" alt="counter">
                <p>OPRS Counter Booking</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isOPRSReport">
            <a (click)="OPRSReportNavigation()">
              <div class="menu-card">
                <img [src]="'assets/images/sso/report.png'" alt="OPRS Reports">
                <p>OPRS Reports</p>
              </div>
            </a>
          </div>
          <div class="col-md-3" *ngIf="isAVLS">
            <a href="https://osrtc.vtpl.info/OSRTC/" target="_blank">
              <div class="menu-card">
                <img [src]="'assets/images/sso/fuel.png'" alt="OPRS Reports">
                <p>Fuel Management</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <p class="powrd-by">Designed, Developed & Powered By Amnex Infotechnologies Pvt Ltd.</p>
  </div>
</div>


<kendo-dialog *ngIf="isOPRSClicked" [minWidth]="500" [width]="500" (close)="closeOPRSCounter()" >
  <kendo-dialog-titlebar>
      OPRS Counter Booking
  </kendo-dialog-titlebar>
  <form  class="k-form"  [formGroup]="OPRSCounterForm">
      <div class="row">
        <!-- <input type="hidden" formControlName="intTerminalID"/>
        <input type="hidden" formControlName="intDepotID"/>
        <input type="hidden" formControlName="strDepotName"/> -->
          <div class="col-12">
              <div class="form-group">
                  <label>Terminal<span class="text-danger"> *</span></label>
                  <input kendoTextBox
                  type="text"
                  formControlName="terminal"
                  class="w-100"
                 />
                  
              </div>
          </div>
        </div>  
        <div class="row">
           <div class="col-12">
              <div class="form-group">
                  <label>Window<span class="text-danger"> *</span></label>

                  <kendo-dropdownlist formControlName="intWindowID" [data]="lstWindow" class="form-control"
                  style="padding:0px;"
                  [textField]="'strOrganizationEntityName'" [valueField]="'intOrganizationEntityID'" [valuePrimitive]="true" required>
                  </kendo-dropdownlist> 
                  <div *ngFor="let validation of validations.message.isRequired">
                    <div class="k-tooltip custom-tooltip-validation" *ngIf="OPRSCounterForm.get('intWindowID').hasError(validation.type) && (OPRSCounterForm.get('intWindowID').dirty || OPRSCounterForm.get('intWindowID').touched)">
                        {{validation.message}} Window
                    </div>
                </div> 
              </div>
          </div>
                  
      </div>
      <input type="hidden" formControlName="intTerminalID"/>
      <input type="hidden" formControlName="intDepotID"/>
      <input type="hidden" formControlName="strDepotName"/>
  </form>
  <div class="text-center py-2" >
      <button class="btn btn-outline-secondary mr-2"  (click)="closeOPRSCounter()">Cancel</button>
      <button class="btn btn-primary" (click)="onOPRSCounterSubmit()" [disabled]="!OPRSCounterForm.valid">Submit</button>
  </div>
</kendo-dialog>

<div kendoDialogContainer></div>

<!-- Kendo Dialog Change Password-->
<kendo-dialog title="Change Password" *ngIf="isChangePassword"
(close)="closeChangePassword('cancel')" [minWidth]="300" [width]="300">
<form novalidate [formGroup]="editChangePasswordForm" autcomplete="off">
  <div class="form-group change-password">
    <kendo-label text="New Password" class="mb-2 d-block product_labelinput">
    </kendo-label>
    <input type="password" class="k-textbox w-100" formControlName="password" autcomplete="off" [(ngModel)]="password"/>
    <div class="k-tooltip k-tooltip-validation d-table text-left"
      *ngIf="editChangePasswordForm.get('password').invalid && (editChangePasswordForm.get('password').touched || editChangePasswordForm.get('password').dirty)">

      <div *ngIf="editChangePasswordForm.get('password').hasError('required')">
        Please enter password </div>

      <div *ngIf="editChangePasswordForm.get('password').errors.minlength">
        Password must be at least 8 characters
      </div>
      
      <div class="error-text" *ngIf="editChangePasswordForm.get('password').hasError('passwordStrength')">
        {{editChangePasswordForm.get('password').errors['passwordStrength']}}
      </div>
    </div>
  </div>

  <div class="form-group change-password mb-0">
    <kendo-label text="Confirm Password" class="mb-2 d-block product_labelinput">
    </kendo-label>
    <input type="password" class="k-textbox w-100" formControlName="confirmpassword" autcomplete="off"
     [(ngModel)]="confirmpassword"/>
    <div class="k-tooltip k-tooltip-validation d-table text-left"
      *ngIf="editChangePasswordForm.get('confirmpassword').invalid && 
      (editChangePasswordForm.get('confirmpassword').touched || 
      editChangePasswordForm.get('confirmpassword').dirty)">

      <div *ngIf="editChangePasswordForm.get('confirmpassword').hasError('required')">
        Please enter password </div>

      <!-- <div *ngIf="editChangePasswordForm.get('confirmpassword').errors.minlength">
        Password must be at least 8 characters
      </div> -->

      <!-- <div class="error-text" *ngIf="editChangePasswordForm.get('confirmpassword').hasError('passwordStrength')">
        {{editChangePasswordForm.get('confirmpassword').errors['passwordStrength']}}
      </div> -->
    </div>
  </div>
  <!-- <div class="d-flex mt-3">
    <button kendoButton class="ml-auto" (click)="closeChangePassword()">Cancel</button>
    <button kendoButton class="ml-2 k-primary px-2" (click) = "updatePassword()">Save</button>
  </div> -->
</form>
<kendo-dialog-actions>
  <button class="k-button" (click)="closeChangePassword()">Cancel</button>
  <button class="k-button k-primary" [disabled]="!editChangePasswordForm.valid" (click)="updatePassword()">Save</button>
</kendo-dialog-actions>
</kendo-dialog>
